/**
 * Simple Structure Type Configuration
 * Defines structure types and their properties
 */

import {
	SIMPLE_STRUCTURE_TYPE,
	type TSimpleStructureType,
} from "@/models/objects/solidMesh/types";

export interface ISimpleStructureTypeConfig {
	id: TSimpleStructureType;
	labelKey: string;
	icon?: string;
	anchorCount?: number; // 0,1,2
	basisPoint1Key?: string;
	basisPoint2Key?: string;
}

export const SIMPLE_STRUCTURE_TYPES: ISimpleStructureTypeConfig[] = [
	{
		id: SIMPLE_STRUCTURE_TYPE.PIPE,
		labelKey: "STRUCTURE_TYPE_PIPE",
		icon: "mdi-pipe",
		anchorCount: 2,
		basisPoint1Key: "PIPE_BASIS_POINT_1",
		basisPoint2Key: "PIPE_BASIS_POINT_2",
	},
	{
		id: SIMPLE_STRUCTURE_TYPE.BOX_CULVERT,
		labelKey: "STRUCTURE_TYPE_BOX_CULVERT",
		icon: "mdi-cube-outline",
		anchorCount: 1,
	},
	{
		id: SIMPLE_STRUCTURE_TYPE.RETAINING_WALL,
		labelKey: "STRUCTURE_TYPE_RETAINING_WALL",
		icon: "mdi-wall",
		anchorCount: 2,
		basisPoint1Key: "WALL_BASIS_POINT_1",
		basisPoint2Key: "WALL_BASIS_POINT_2",
	},
	{
		id: SIMPLE_STRUCTURE_TYPE.MANHOLE,
		labelKey: "STRUCTURE_TYPE_MANHOLE",
		icon: "mdi-circle-multiple-outline",
		anchorCount: 1,
	},
	{
		id: SIMPLE_STRUCTURE_TYPE.MANUAL,
		labelKey: "STRUCTURE_TYPE_MANUAL",
		icon: "mdi-pencil",
		anchorCount: 1,
	},
];

export const getStructureTypeConfig = (
	type: TSimpleStructureType,
): ISimpleStructureTypeConfig | undefined => {
	return SIMPLE_STRUCTURE_TYPES.find((config) => config.id === type);
};
